import { PartnerPremiumSource } from "@/types/partner/Partner";

export function formatPartnerPremiumLabel(
  isPremium?: boolean,
  premiumSource?: PartnerPremiumSource | null,
): string {
  if (!isPremium) {
    return "Free";
  }

  if (premiumSource === "VOUCHER") {
    return "Voucher";
  }

  if (premiumSource === "PAID") {
    return "Pago";
  }

  return "Premium";
}

export function partnerPremiumBadgeClass(
  isPremium?: boolean,
  premiumSource?: PartnerPremiumSource | null,
): string {
  if (!isPremium) {
    return "premium-badge--free";
  }

  if (premiumSource === "VOUCHER") {
    return "premium-badge--voucher";
  }

  return "premium-badge--premium";
}
